import { render, staticRenderFns } from "./StoriesArticleOverlapCopy.vue?vue&type=template&id=149649f2&scoped=true&"
import script from "./StoriesArticleOverlapCopy.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleOverlapCopy.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleOverlapCopy.vue?vue&type=style&index=0&id=149649f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149649f2",
  null
  
)

export default component.exports